
import { OptionsClass } from "@/domain/entities/MainApp";
import { prop, Vue } from "vue-class-component";

export type PaymentInformationSectionProp = {
  paymentMethod: OptionsClass;
};

class Props {
  modelValue = prop<PaymentInformationSectionProp>({
    default: {
      paymentMethod: new OptionsClass()
    },
    required: true,
    type: Object
  });
}

class PaymentInformationSection extends Vue.with(Props) {
  get paymentMethodList() {
    return [
      {
        name: this.$t("clientManagement.registrationForm.payment.invoice").toString(),
        value: "invoice"
      },
      {
        name: this.$t("clientManagement.registrationForm.payment.splitBill").toString(),
        value: "split_bill"
      }
    ];
  }

  get formModel() {
    return this.modelValue;
  }

  set formModel(val) {
    this.$emit("update:modelValue", val);
  }
}
export default PaymentInformationSection;
